import { NavLink } from 'react-router-dom'

export type RAGRoute = 'knowledge' | 'search' | 'cognition' | 'governance' | 'observability' | 'settings'

const routes: { id: RAGRoute; label: string; path: string }[] = [
    { id: 'knowledge', label: 'Knowledge Base', path: '/rag/knowledge' },
]

export function RAGNavigation() {
    return (
        <div className="border-b border-white/10">
            <div className="flex gap-8 px-8">
                {routes.map((route) => (
                    <NavLink
                        key={route.id}
                        to={route.path}
                        className={({ isActive }) =>
                            `pb-4 px-2 border-b-2 transition-all ${isActive
                                ? 'text-white font-semibold border-blue-500'
                                : 'text-gray-400 font-medium border-transparent hover:text-gray-300 hover:border-gray-700'
                            }`
                        }
                    >
                        {route.label}
                    </NavLink>
                ))}
            </div>
        </div>
    )
}
